import { NgModule } from '@angular/core';
import { LibraryComponent } from './library.component';

@NgModule({
  declarations: [LibraryComponent],
  imports: [
  ],
  exports: [LibraryComponent],
})
export class LibraryModule { }
